module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "partnum",
    attrs: {
      "id": "Part_One"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page1",
      "title": "1"
    }
  }, [_vm._v("PART ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "parttitle"
  }, [_vm._v("THE FRENCH WAR—THE IDEA, AND BULLETS")]), _vm._v(" "), _c('p', {
    staticClass: "indentpart"
  }, [_vm._v("***")]), _vm._v(" "), _c('p', {
    staticClass: "indentpart"
  }, [_vm._v("General Vo Nguyen Giap:")]), _vm._v(" "), _c('p', {
    staticClass: "indentpart1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“C’est fini. It’s over. We will yield no longer.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indentpart"
  }, [_vm._v("Hanoi, December 18, 1946")]), _vm._v(" "), _c('p', {
    staticClass: "indentpartd"
  }, [_vm._v("***")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04b8e607","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/11_Part_One.vue
// module id = 90
// module chunks = 0